import * as React from 'react';

import { PartnersSection, IPartner } from 'shared/components/PartnersSection';
import { useCarousel } from 'shared/hooks';

import ChevronRightG from 'shared/components/PartnersSection/assets/ChevronRightG.svg';
import realtor1 from 'shared/components/PartnersSection/assets/realtor-1.jpg';
import realtor3 from 'shared/components/PartnersSection/assets/realtor-3.jpg';
import realtor4 from 'shared/components/PartnersSection/assets/realtor-4.jpg';
import realtor5 from 'shared/components/PartnersSection/assets/realtor-5.jpg';
import realtor6 from 'shared/components/PartnersSection/assets/realtor-6.jpg';
import realtor7 from 'shared/components/PartnersSection/assets/realtor-7.jpg';
import realtor10 from 'shared/components/PartnersSection/assets/realtor-10.jpg';
import { setModalFormOpen } from '../../slices';
import { useDispatch } from 'react-redux';
import { trackCtaClick } from './tracking';

const PARTNERS: IPartner[] = [
  {
    photo: realtor5,
    name: 'Ольга',
    experience: 'Стаж 7 лет',
    description: 'Фокусируюсь на покупке, обожаю находить лучшие предложения для клиентов',
  },
  {
    photo: realtor1,
    name: 'Лейла',
    experience: 'Стаж 8 лет',
    description: 'Работаю с новостройками, активно общаюсь с клиентами и ценю оперативность',
  },
  {
    photo: realtor10,
    name: 'Евгений',
    experience: 'Стаж 10 лет',
    description: 'Эксперт в загородной недвижимости, люблю сложные проекты',
  },
  {
    photo: realtor3,
    name: 'Анатолий',
    experience: 'Стаж 16 лет',
    description: 'У меня огромный опыт сделок со вторичкой, люблю деловой подход и системность',
  },
  {
    photo: realtor4,
    name: 'Татьяна',
    experience: 'Стаж 8 лет',
    description: 'Занимаюсь недвижимостью для инвестиций, моя цель — максимальная прибыль для вас',
  },
  {
    photo: realtor6,
    name: 'Наталья',
    experience: 'Стаж 14 лет',
    description: 'Работаю с загородной недвижимостью, обожаю природу и спокойствие',
  },
  {
    photo: realtor7,
    name: 'Алексей',
    experience: 'Стаж 12 лет',
    description: 'Специализация — элитная недвижимость, ориентируюсь на качественный сервис',
  },
];

export const PartnersSectionContainer: React.FC = () => {
  const rootRef = React.useRef<HTMLDivElement>(null);
  const trackRef = React.useRef<HTMLDivElement>(null);
  const prevButtonRef = React.useRef<HTMLButtonElement>(null);
  const nextButtonRef = React.useRef<HTMLButtonElement>(null);

  const dispatch = useDispatch();

  const { stepBy } = useCarousel({
    rootRef,
    trackRef,
    prevButtonRef,
    nextButtonRef,
    cardCount: PARTNERS.length + 1,
  });

  const handleModalOpenClick = React.useCallback(() => {
    trackCtaClick();
    dispatch(setModalFormOpen('ticket'));
  }, [dispatch]);

  return (
    <PartnersSection
      partners={PARTNERS}
      rootRef={rootRef}
      trackRef={trackRef}
      prevButtonRef={prevButtonRef}
      nextButtonRef={nextButtonRef}
      onPrevClick={() => stepBy(-1)}
      onNextClick={() => stepBy(1)}
      onCtaClick={handleModalOpenClick}
      prevArrowIcon={ChevronRightG}
    />
  );
};
